import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import axios from "axios";
import api_address from "../../../../constants/config";
import Cookies from "js-cookie";
import { FileTextOutlined, PaperClipOutlined } from "@ant-design/icons";
import { handleOpenPDFFromAWS } from "../../../User/Dashboard/SurveyHistory/UserAssessment";
import {
  ModalMask,
  ModalContainer,
  CloseButton,
  AssessmentList,
  AssessmentItem,
  AssessmentTitle,
  AssessmentInfo,
  AssessmentDate,
  AssessmentAgency,
} from "./styles";

interface AssessmentModalProps {
  show: boolean;
  userId: number;
  userUUID: string;
  onClose: () => void;
}

interface Attachment {
  id: number;
  name: string;
  createdAt: string;
}

interface Assessment {
  id: number;
  name: string;
  evaluationName: string;
  evaluationDate: string;
  evaluationAgency: string;
  createdAt: string;
  attachments: Attachment[];
}

interface AssessmentModalState {
  assessments: Assessment[];
  loading: boolean;
}

class AssessmentModal extends Component<
  AssessmentModalProps & WithTranslation,
  AssessmentModalState
> {
  constructor(props: AssessmentModalProps & WithTranslation) {
    super(props);
    this.state = {
      assessments: [],
      loading: true,
    };
  }

  componentDidMount() {
    if (this.props.show) {
      this.fetchAssessments();
    }
  }

  componentDidUpdate(prevProps: AssessmentModalProps) {
    if (!prevProps.show && this.props.show) {
      this.fetchAssessments();
    }
  }

  fetchAssessments = async () => {
    try {
      const token = Cookies.get("token");
      const res = await axios.get(
        api_address + "api/therapist/user-assessment-list/" + this.props.userId,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { userAssessmentList } = res.data;

      // Ensure all assessments have an attachments array
      const processedList = userAssessmentList.map((assessment: any) => {
        return {
          ...assessment,
          attachments: assessment.attachments || [],
        };
      });

      this.setState({
        assessments: processedList,
        loading: false,
      });
    } catch (err) {
      console.error("Error fetching assessments:", err);
      this.setState({ loading: false });
    }
  };

  handleOpenAssessment = (assessmentName: string) => {
    handleOpenPDFFromAWS({
      folderName: `user_assessments/${this.props.userUUID}`,
      fileName: assessmentName,
    });
  };

  render() {
    const { t, show, onClose } = this.props;
    const { assessments, loading } = this.state;

    if (!show) return null;

    return (
      <ModalMask open={show}>
        <ModalContainer>
          <CloseButton onClick={onClose}>×</CloseButton>
          <h2>{t("therapist.casePanel.assessmentModal.title")}</h2>
          {loading ? (
            <p>{t("therapist.casePanel.assessmentModal.loading")}</p>
          ) : assessments.length === 0 ? (
            <p>{t("therapist.casePanel.assessmentModal.noAssessments")}</p>
          ) : (
            <AssessmentList>
              {assessments.map((assessment) => (
                <AssessmentItem key={assessment.id}>
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => this.handleOpenAssessment(assessment.name)}
                  >
                    <AssessmentTitle>
                      <FileTextOutlined
                        style={{ marginRight: "8px" }}
                        rev={undefined}
                      />
                      {assessment.evaluationName}
                    </AssessmentTitle>
                    <AssessmentInfo>
                      <AssessmentAgency>
                        {assessment.evaluationAgency}
                      </AssessmentAgency>
                      <AssessmentDate>
                        {new Date(
                          assessment.evaluationDate
                        ).toLocaleDateString()}
                      </AssessmentDate>
                    </AssessmentInfo>
                  </div>
                </AssessmentItem>
              ))}
            </AssessmentList>
          )}
        </ModalContainer>
      </ModalMask>
    );
  }
}

export default withTranslation()(AssessmentModal);
